<script>
export default {
  methods: {},
  props: ["component", "handler"],
  translate25Context: 'troubleshooting',
  mounted: function () {
  },
};
</script>

<template>
  <div class="troubleshooting-main-page">
    <f-form>
      <template #title>
        <f-icon icon="fa6-circle-question"></f-icon>{{ $vt('Help') }}
      </template>
      <template #content>
        <f-hint icon="fa6-circle-info">
          <template #title>{{ $vt('Use the following links to check that every network prerequises are met.') }}</template>
        </f-hint>
        <div class="troubleshooting-item" v-for="item in $options.filters.byWeight(component.items)" :key="item['#id']">
          <vue-angular-place-holder :component="item.component" :handler="handler"></vue-angular-place-holder>
        </div>
      </template>
    </f-form>
  </div>
</template>

<style lang="scss">
.troubleshooting-main-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .troubleshooting-item {
    display: flex;
    flex-direction: column;
  }

  .troubleshooting-page-url {
    display: flex;
    align-items: center;

    .troubleshooting-page-url-label {
      margin-right: auto;
      font-size: 14px;
      color: var(--white-a25);
      font-weight: 700;
      text-transform: uppercase;
    }

    .troubleshooting-page-url-label2 {
      margin-right: auto;
      font-size: 14px;
      color: var(--white-a25);
      font-weight: 700;
    }
  }
}
</style>